export enum SignInMethod {
  SSO = 'SSO',
  DIRECT = 'DIRECT',
}
